"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewRoot = exports.SearchPreviewContent = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _getMobileCssVariable = require("../../../../utils/getMobileCssVariable");
var _constants = require("../../../SearchPreview/constants");
var _constants2 = require("../../constants");
const SearchPreviewRoot = exports.SearchPreviewRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  background: theme.palette.common.white,
  boxSizing: 'border-box',
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  left: 0,
  padding: theme.spacing(3, 0),
  position: 'absolute',
  top: _presentationUtils.SEARCH_INPUT_HEIGHT,
  transition: `top ${_presentationUtils.CSS_HEIGHT_ANIMATION}`,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    position: 'static',
    padding: 0,
    borderRadius: theme.spacing(0, 0, 3, 3)
  }
}));
const SearchPreviewContent = exports.SearchPreviewContent = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  innerHeight,
  isTopBannerVisible,
  showSearchOnScroll,
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  height: `calc(${innerHeight}px - ${_presentationUtils.SEARCH_PREVIEW_SEE_ALL_HEIGHT}px - ${(0, _getMobileCssVariable.getSearchInputTopAttribute)({
    isTopBannerVisible,
    showSearchOnScroll
  })} - ${_presentationUtils.SEARCH_INPUT_HEIGHT}px)`,
  position: 'relative',
  width: '100%',
  overscrollBehaviorY: 'contain',
  overflowY: 'scroll',
  [theme.breakpoints.up('md')]: {
    height: `min(${_constants.MAX_SEARCH_HEIGHT - _constants2.SEARCH_INPUT_BOX_HEIGHT}px, calc(${innerHeight}px - ${_presentationUtils.CSS_DESKTOP_HEIGHT}))`,
    overflowY: 'visible'
  }
}));
